export interface Category {
  slug: string;
  name: string;
  desc: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "yule",
    name: "娱乐圈",
    desc: "艺人与团队的台前幕后，合约、档期与舆论走向的原始线索。",
    icon: "ri-mic-line",
  },
  {
    slug: "caijing",
    name: "商业财经",
    desc: "招商政策、资本动作与高管变动背后的真实推手。",
    icon: "ri-line-chart-line",
  },
  {
    slug: "hulianwang",
    name: "互联网",
    desc: "组织调整、流量规则与产品决策的内部脉络。",
    icon: "ri-code-s-slash-line",
  },
  {
    slug: "zongyi",
    name: "综艺影视",
    desc: "开机、改档与撤档之间，那些没写进通告单的部分。",
    icon: "ri-film-line",
  },
  {
    slug: "zhichang",
    name: "职场爆料",
    desc: "薪酬、绩效与晋升通道的一手观察，来自内部人的记录。",
    icon: "ri-briefcase-line",
  },
  {
    slug: "minsheng",
    name: "城市民生",
    desc: "新规、出行与公共服务调整前的讨论与博弈。",
    icon: "ri-building-2-line",
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);

export const popularTags: string[] = [
  "独家爆料",
  "知情人透露",
  "一手信息",
  "小道消息",
  "内部文件",
  "深夜会议",
  "撤档内幕",
  "组织调整",
];